import React from 'react';

export default function CheckboxEditor(props) {
    return <div></div>;
}
